import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Table, Tag } from "antd"
import React, { useEffect, useRef, useState } from "react"
import {SearchOutlined } from '@ant-design/icons';
import { SaleOrderService } from "@gtpl/shared-services/sale-management";
import Highlighter from 'react-highlight-words';
import { ProductGradeReportReq } from "@gtpl/shared-models/sale-management";
import moment from "moment";
import { Excel } from "antd-table-saveas-excel";

export const ProductGradeReport =() =>{
    const [data,setData] = useState([])
    const [products,setProducts] = useState([])
    const searchInput = useRef(null);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState<number>(100);
    const service = new SaleOrderService();
    const [form] = Form.useForm();
    const [grades,setGrades] = useState([])
    const { Option } = Select;
    const { RangePicker } = DatePicker;
    const [buyers,setBuyers] = useState([])
    const [countries,setCountries] = useState([])
    const [foodId,setFoodId] = useState()
    const [val1Id,setVal1Id] = useState()
    const [val2Id,setVal2Id] = useState()
    const [val3Id,setVal3Id] = useState()
    const [val4Id,setVal4Id] = useState()
    const [val5Id,setVal5Id] = useState()
    const [productId,setProductId] = useState()

useEffect(()=>{
    // getData()
    getdropdowns()
},[])
const getData=()=>{
    const req = new ProductGradeReportReq()
    if(form.getFieldValue('poDate')!= undefined){
        req.poFromDate = moment(form.getFieldValue('poDate')[0]).format('YYYY-MM-DD')
        req.poToDate = moment(form.getFieldValue('poDate')[1]).format('YYYY-MM-DD')

    }
    if(form.getFieldValue('product')!= undefined){
        req.product = form.getFieldValue('product')
        req.foodType =foodId
        req.valAdd1 = val1Id
        req.valAdd2 = val2Id
        req.valAdd3 = val3Id
        req.valAdd4 = val4Id
        req.valAdd5 = val5Id
        req.productId = productId

    }
    if(form.getFieldValue('grade')!= undefined){
        req.grade = form.getFieldValue('grade')
    }
    if(form.getFieldValue('buyerId')!= undefined){
      req.buyerId = form.getFieldValue('buyerId')
  }
  if(form.getFieldValue('countryId')!= undefined){
    req.countryId = form.getFieldValue('countryId')
}
    service.getProductGradeAnalysisReportData(req).then((res)=>{
        if(res.status){
            setData(res.data)
        }else{
            setData([])
        }
    })
}
const getdropdowns =()=>{
    service.getProductGradeAnalysisReportProducts().then((res)=>{
        if(res.status){
            setProducts(res.data)
        }else{
            setProducts([])
        }
    })
    service.getProductGradeAnalysisReportGrades().then((res)=>{
        if(res.status){
            setGrades(res.data)
        }else{
            setGrades([])
        }
    })
    service.getProductGradeAnalysisReportBuyers().then((res)=>{
      if(res.status){
          setBuyers(res.data)
      }else{
        setBuyers([])
      }
  })
  service.getProductGradeAnalysisReportCountry().then((res)=>{
    if(res.status){
        setCountries(res.data)
    }else{
      setCountries([])
    }
})
}
const getMonthName =['January','February','March','April','May','June','July','Agust','September','October','November','December']
    const getColumnSearchProps = (dataIndex: any) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
            : false,
        onFilterDropdownVisibleChange: visible => {
          if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
          text ? (
            searchedColumn === dataIndex ? (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ) : text
          )
            : null
    
      });
    
      function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
      };
    
      const columns: any[] = [
        {
          title: 'S No',
          key: 'sno',
          width: 70,
          render: (text, object, index) => (page-1) * 10 +(index+1)
        },
        {
          title: "Buyer Name",
          dataIndex: "buyerName",
         
          sorter: (a, b) => a.buyerName?.localeCompare(b.buyerName),
          sortDirections: ['descend', 'ascend'],
          // ...getColumnSearchProps('buyerName')
    
      },
        {
          title: "Product",
          dataIndex: "variety",
        
          sorter: (a, b) => a.variety?.localeCompare(b.variety),
          sortDirections: ['descend', 'ascend'],
          // ...getColumnSearchProps('variety'),
          render: (text: any, record: any) => {
              return record.variety ? record.variety : '-';
            },
      
      },
    
        {
          title: 'Grade',
          dataIndex: 'grade',
          // sorter: (a, b) => {
          //   const minGradeA = a.items?.[0]?.minGrade ?? 0; 
          //   const minGradeB = b.items?.[0]?.minGrade ?? 0;
          //   return minGradeA - minGradeB;
          // },
          // sortDirections: ['descend', 'ascend'],
          render: (text: any, data: any) => {
            return data.grade?data.grade:'-'
          },
     
        },
       
        {
          title: 'Price',
          dataIndex: 'price',
          ...getColumnSearchProps('price'),
          render: (text: any, record: any) => {
            return(<Tag> {record.price ? record.price : '-'}</Tag>);
          },
    
        },
        {
          title: 'PO Number',
          dataIndex: 'poNum',
          sorter: (a, b) => a.poNum?.localeCompare(b.poNum),
          sortDirections: ['descend', 'ascend'],
          ...getColumnSearchProps('poNum'),
          render: (text: any, record: any) => 
            record.poNum ? record.poNum : '-'
       },
        {
          title: 'PO Month',
          dataIndex: 'month',
        //  ...getColumnSearchProps('month'),
          render: (text: any, record: any) => 
            record.month ? `${getMonthName[Number(record.month) - 1]}-${record.year}` : '-'
       },
        {
          title: 'Country',
          dataIndex: 'countryName',
          
          ...getColumnSearchProps('countryName'),
          render: (text: any, record: any) => {
            return record.countryName ? record.countryName : '-';
          },
        },
        {
          title: 'Destination',
          dataIndex: 'destination',
          sorter: (a, b) => a.destination?.localeCompare(b.destination),
          sortDirections: ['descend', 'ascend'],
          ...getColumnSearchProps('destination'),
          render: (text: any, record: any) => {
            return record.destination ? record.destination : '-';
          },
        },
        {
          title: 'Status',
          dataIndex: 'status',
          fixed:'right',
          ...getColumnSearchProps('status'),
          render: (text: any, record: any) => {
            return record.status ? record.status : '-';
          },
        },
     ];

     const excelColumns: any[] = [
      {
        title: 'S No',
        key: 'sno',
        width: 70,
        render: (text, object, index) => (page-1) * 10 +(index+1)
      },
      {
        title: "Buyer Name",
        dataIndex: "buyerName",
       
        sorter: (a, b) => a.buyerName?.localeCompare(b.buyerName),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('buyerName')
  
    },
      {
        title: "Product",
        dataIndex: "variety",
      
        sorter: (a, b) => a.variety?.localeCompare(b.variety),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('variety'),
        render: (text: any, record: any) => {
            return record.variety ? record.variety : '-';
          },
    
    },
  
      {
        title: 'Grade',
        dataIndex: 'grade',
        // sorter: (a, b) => {
        //   const minGradeA = a.items?.[0]?.minGrade ?? 0; 
        //   const minGradeB = b.items?.[0]?.minGrade ?? 0;
        //   return minGradeA - minGradeB;
        // },
        // sortDirections: ['descend', 'ascend'],
        render: (text: any, data: any) => {
          return data.grade?data.grade:'-'
        },
   
      },
     
      {
        title: 'Price',
        dataIndex: 'price',
        ...getColumnSearchProps('price'),
        render: (text: any, record: any) => {
          return record.price ? record.price : '-'
        },
  
      },
      {
        title: 'PO Number',
        dataIndex: 'poNum',
        
        // ...getColumnSearchProps('month'),
        render: (text: any, record: any) => 
          record.poNum ? record.poNum : '-'
     },
      {
        title: 'PO Month',
        dataIndex: 'month',
        
        // ...getColumnSearchProps('month'),
        render: (text: any, record: any) => 
          record.month ? `${getMonthName[Number(record.month) - 1]}-${record.year}` : '-'
     },
      {
        title: 'Country',
        dataIndex: 'countryName',
        
        ...getColumnSearchProps('countryName'),
        render: (text: any, record: any) => {
          return record.countryName ? record.countryName : '-';
        },
      },
      {
        title: 'Destination',
        dataIndex: 'destination',
        ...getColumnSearchProps('destination'),
        render: (text: any, record: any) => {
          return record.destination ? record.destination : '-';
        },
      },
      {
        title: 'Status',
        dataIndex: 'status',
        ...getColumnSearchProps('status'),
        render: (text: any, record: any) => {
          return record.status ? record.status : '-';
        },
      },
   ];
  const onReset = () => {
    form.resetFields();
    setData([]);
  };
  const exportExcel = () =>{
    const excel = new Excel();
    excel
.addSheet('Product And Grade Analysis Report')
.addColumns(excelColumns)
.addDataSource(data, { str2num: true })
.saveAs('Product-And-Grade-Analysis-Report.xlsx');
  }
  const productChange=(val,option)=>{
setFoodId(option.foodId)
setVal1Id(option.val1Id)
setVal2Id(option.val2Id)
setVal3Id(option.val3Id)
setVal4Id(option.val4Id)
setVal5Id(option.val5Id)
setProductId(option.productId)

  }
    return(
        <Card size="small"   title={<span style={{ color: 'white' }}>Product And Grade Price Analysis Report </span>}
        extra={<Button onClick={exportExcel}>Get Excel</Button>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
            <Form form={form} layout="vertical" onFinish={getData}>
            <Row gutter={24}>
             <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 5 }}>
            <Form.Item
                name="buyerId"
                label="Buyer"
               
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    // filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Buyer"
                    allowClear
                    style={{ width: '100%' }}
                     >
                    {buyers.map(dropData => {
                        return <Option value={dropData.buyerId}>{dropData.buyerName}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
                name="product"
                label="Product"
               
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    // filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Product"
                    allowClear
                    style={{ width: '100%' }}
                    onChange={productChange}
                     >
                    {products.map(dropData => {
                        return <Option value={dropData.product} foodId={dropData.foodTypeId} val1Id={dropData.valAdd1Id} val2Id={dropData.valAdd2Id} val3Id={dropData.valAdd3Id} val4Id={dropData.valAdd4Id} val5Id={dropData.valAdd5Id} productId={dropData.productId}>{dropData.product}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
            <Form.Item
                name="grade"
                label="Grade"
               
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select grade"
                    allowClear
                    style={{ width: '100%' }}
                     >
                    {grades.map(dropData => {
                        return <Option value={dropData.grade}>{dropData.grade}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
            <Form.Item
                name="countryId"
                label="Country"
               
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    // filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Country"
                    allowClear
                    style={{ width: '100%' }}
                     >
                    {countries.map(dropData => {
                        return <Option value={dropData.countryId}>{dropData.countryName}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>
         <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 5 }}>
                    <Form.Item label="PO Date" name="poDate" 
                    // rules={[{ required: true, message: 'PO Date is required' }]}
                     >
                      <RangePicker />
                    </Form.Item>
        </Col>
          <Col style={{ paddingLeft:'inherit',marginTop: '30px' }} span={2} >            <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Get Report
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col style={{ marginTop: '30px' }} span={2}>           
                    <Form.Item>
                      <Button type="primary" htmlType="reset" onClick={onReset}>
                        Reset
                      </Button>
                    </Form.Item>
                  </Col>
            </Row>
            </Form>
            <Row gutter={16} style={{height:'45px'}}>
            <Col span={4}>
              <Tag color="#cb9860" style={{ display: 'flex', color: 'black', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
                Total No.Of Buyers: {new Set(data.map((record: any) => record.buyerName).filter(Boolean)).size}
              </Tag>
              </Col>
              <Col span={4}>
              <Tag color="#a9b9a2" style={{ display: 'flex', color: 'black', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
                Total No.Of Products: {new Set(data.map((record: any) => record.variety).filter(Boolean)).size}
              </Tag>
              </Col>
              <Col span={4}>
              <Tag color="#ACD3A8" style={{ display: 'flex', color: 'black', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
                Total No.Of PO's: {new Set(data.map((record: any) => record.poNum).filter(Boolean)).size}
              </Tag>
              </Col>
              </Row>
            {data.length>0 &&(
            <Table columns={columns} dataSource={data} size="small"  pagination={{ pageSize: 100 }} scroll={{x:'max-content'}}/>
            )}
        </Card>
    )
}
export default ProductGradeReport